/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PatientProcedureInvestigation from './patient-procedure-investigation';
import PatientProcedureInvestigationDetail from './patient-procedure-investigation-detail';
import PatientProcedureInvestigationUpdate from './patient-procedure-investigation-update';
import PatientProcedureInvestigationDeleteDialog from './patient-procedure-investigation-delete-dialog';

const PatientProcedureInvestigationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PatientProcedureInvestigation />} />
    <Route path="new" element={<PatientProcedureInvestigationUpdate />} />
    <Route path=":id">
      <Route index element={<PatientProcedureInvestigationDetail />} />
      <Route path="edit" element={<PatientProcedureInvestigationUpdate />} />
      <Route path="delete" element={<PatientProcedureInvestigationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PatientProcedureInvestigationRoutes;
